import parse from "html-react-parser";
import useViewSolution from "./useViewSolution";

const ViewSolution = () => {
  const {
    current,
    index,
    testResult,
    testQuestions,
    renderOptionsList,
    previousHandler,
    nextHandler,
    getUserAnswer,
  } = useViewSolution();
  return (
    <div className="p-10 mt-10 flex flex-col gap-5 border border-gray-300 rounded-lg shadow-md">
      <div className="flex w-full">
        <div className="w-full border rounded-sm p-5 flex flex-col">
          <span className="font-bold  mb-5">Question {index}</span>
          <hr className="mb-5" />
          <span
            className="font-bold mb-5 flex items-center medium-text dark-text"
            style={{ fontSize: "20px" }}
          >
            {parse(testQuestions[current]?.TestQuestionsPtr?.QuesTitle || "")}
          </span>
          {testQuestions[current]?.TestQuestionsPtr && (
            <ul className="space-y-2">
              {renderOptionsList(testQuestions[current]?.TestQuestionsPtr)?.map(
                (x, i) => (
                  <li
                    key={x?.id}
                    className={`flex items-center px-4 py-2 rounded-lg cursor-pointer ${
                      +testQuestions[current]?.TestQuestionsPtr
                        ?.CorrectAnswer[0] &&
                      +testQuestions[current]?.TestQuestionsPtr
                        ?.CorrectAnswer[0] ===
                        i + 1
                        ? "bg-green-300"
                        : "bg-white"
                    }`}
                  >
                    <input
                      type="radio"
                      id={`options${testQuestions[current]?.TestQuestionsPtr?.objectId}${x.id}`}
                      name={`options${testQuestions[current]?.TestQuestionsPtr?.objectId}`}
                      className="mr-2 cursor-pointer"
                      checked={getUserAnswer(
                        testQuestions[current]?.TestQuestionsPtr?.objectId,
                        i + 1
                      )}
                    />
                    <label
                      htmlFor={`options${testQuestions[current]?.TestQuestionsPtr?.objectId}${x.id}`}
                      className="cursor-pointer"
                    >
                      {x.id})&nbsp; {parse(x.text || "")}
                    </label>

                    {getUserAnswer(
                      testQuestions[current]?.TestQuestionsPtr?.objectId,
                      i + 1
                    ) &&
                      +testQuestions[current]?.TestQuestionsPtr
                        ?.CorrectAnswer[0] !==
                        i + 1 && (
                        <span className="text-red-500 ml-2 font-bold">
                          &#10005;
                        </span>
                      )}
                    {+testQuestions[current]?.TestQuestionsPtr
                      ?.CorrectAnswer[0] ===
                      i + 1 && (
                      <span className="text-green-500 ml-2 font-bold">
                        &#10003;
                      </span>
                    )}
                  </li>
                )
              )}
            </ul>
          )}

          <hr className="mb-5 mt-5" />
          <div className="bg-green-300 p-6 my-6 border border-green-400 rounded-md flex flex-col gap-4">
            <span className="font-bold">Reference:</span>
            <div className="text-sm">
              {parse(
                testQuestions[current]?.TestQuestionsPtr?.SolutionInfo || ""
              )}
            </div>
          </div>
          <hr className="mb-5 mt-5" />
          <div className="flex justify-between items-center">
            <div className="flex gap-2 items-center">
              <button
                className="py-2 px-4 flex items-center border border-gray-300 uppercase rounded text-gray-800 font-bold text-xl hover:bg-gray-100"
                onClick={() => previousHandler(current)}
                disabled={!current}
              >
                <span style={{ fontSize: "30px", margin: "-4px 10px 0px" }}>
                  &#171;
                </span>{" "}
                Back
              </button>
              <button
                disabled={current === testQuestions?.length - 1}
                className="py-2 px-4 flex items-center border border-gray-300 uppercase rounded text-gray-800 font-bold text-xl hover:bg-gray-100"
                onClick={() => {
                  nextHandler(
                    current,
                    testQuestions[current]?.TestQuestionsPtr?.objectId
                  );
                }}
              >
                Next
                <span style={{ fontSize: "30px", margin: "-4px 10px 0px" }}>
                  &#187;
                </span>
              </button>
            </div>
            <div></div>
          </div>
        </div>
        <div className="w-2/4 border p-2 pt-5">
          <div className="flex gap-5 flex-wrap mb-5 p-5 border rounded border-green-400">
            <div className="flex items-center gap-3">
              <span
                className="bg-orange-600 h-12 w-12 flex items-center justify-center rounded text-xl text-white font-semibold"
                style={{ borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70% " }}
              >
                {
                  testResult?.TestAnsweredPtr?.SubmittedAnswers?.filter(
                    (s) => !s
                  )?.length
                }
              </span>
              <span className="text-yellow-900 font-semibold text-xl">
                Not Answered
              </span>
            </div>
            <div className="flex items-center gap-3">
              <span
                className="bg-green-700 h-12 w-12 flex items-center justify-center text-xl text-white font-semibold "
                style={{ borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70% " }}
              >
                {
                  testResult?.TestAnsweredPtr?.SubmittedAnswers?.filter(
                    (s) => s
                  )?.length
                }
              </span>
              <span className="text-green-700 font-semibold text-xl">
                Answered
              </span>
            </div>
          </div>
          <div className="grid grid-cols-10 items-center gap-1">
            {/* {questionsInfoSummary?.map((x, i) => (
              <span
                key={x?.id}
                onClick={() => handleChange(i, x?.id)}
                className={`p-2 border flex items-center justify-center cursor-pointer hover:font-semibold ${
                  x.status === "notAnswered"
                    ? "bg-orange-600 text-white rounded-lg font-semibold "
                    : x.status === "markedForReview"
                    ? "bg-cyan-700 rounded-full text-white font-semibold"
                    : x.status === "answered"
                    ? "bg-green-700 text-white font-semibold rounded-lg"
                    : x.status === "saveAndMark"
                    ? "bg-purple-900 text-white font-semibold rounded-full"
                    : i === current && !x.status
                    ? "bg-gray-300 border border-gray-400 rounded font-semibold"
                    : "bg-gray-300 border border-gray-400 rounded font-semibold"
                }`}
                style={
                  x.status === "answered" || x.status === "notAnswered"
                    ? { borderRadius: "30% 70% 70% 30% / 30% 30% 70% 70% " }
                    : {}
                }
              >
                {++i}
              </span>
            ))} */}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewSolution;
